import { normalize } from 'normalizr'
import { Schemas } from '@redux/schema'
import { updateEntities } from '@redux/entities'

import api from '@functions/api'

import { handleError } from '../utils'

const FETCH_REQUEST = 'realbase/fontFamily/FETCH_REQUEST'
const FETCH_SUCCESS = 'realbase/fontFamily/FETCH_SUCCESS'
const FETCH_FAILURE = 'realbase/fontFamily/FETCH_FAILURE'

const CREATE_REQUEST = 'realbase/fontFamily/CREATE_REQUEST'
const CREATE_SUCCESS = 'realbase/fontFamily/CREATE_SUCCESS'
const CREATE_FAILURE = 'realbase/fontFamily/CREATE_FAILURE'

const UPDATE_REQUEST = 'realbase/fontFamily/UPDATE_REQUEST'
const UPDATE_SUCCESS = 'realbase/fontFamily/UPDATE_SUCCESS'
const UPDATE_FAILURE = 'realbase/fontFamily/UPDATE_FAILURE'

// Initial State
const initialState = {
  creating: false,
  errors: [],
  loaded: false,
  loadedForKeys: [],
  loading: false,
  updating: false,
}

// Actions
export function fetchRequest(payload = {}){
  return {
    type: FETCH_REQUEST,
    loadedForKeys: payload.loadedForKeys,
  }
}

export function fetchSuccess(){
  return {
    type: FETCH_SUCCESS,
  }
}

export function fetchFailure(errors = []){
  return {
    type: FETCH_FAILURE,
    errors,
  }
}

export function createRequest(){
  return {
    type: CREATE_REQUEST,
  }
}

export function createSuccess(){
  return {
    type: CREATE_SUCCESS,
  }
}

export function createFailure(errors = []){
  return {
    type: CREATE_FAILURE,
    errors,
  }
}

export function updateRequest(){
  return {
    type: UPDATE_REQUEST,
  }
}

export function updateSuccess(){
  return {
    type: UPDATE_SUCCESS,
  }
}

export function updateFailure(errors = []){
  return {
    type: UPDATE_FAILURE,
    errors,
  }
}

// Action Creators
export function loadFontFamilies(options){
  const { entityKey } = options

  return (dispatch, getState) => {
    const loadedForKeys = [...getState().fontFamilies.loadedForKeys]

    if (entityKey) loadedForKeys.push(entityKey)

    dispatch(fetchRequest({ loadedForKeys }))

    const promise = api('/font_families.json', options)
      .then(({ data }) => {
        const normalizedJson = normalize(data, Schemas.FONT_FAMILY_ARRAY)
        dispatch(updateEntities(normalizedJson))
        dispatch(fetchSuccess())

        return { success: true, data }
      })
      .catch((data) => {
        const errors = handleError(data)
        dispatch(fetchFailure(errors))

        return { success: false, errors }
      })

    return promise
  }
}

export function createFontFamily(fontFamily, options){
  const config = {
    method: 'POST',
    data: JSON.stringify({
      font_family: fontFamily,
    }),
  }

  return (dispatch) => {
    dispatch(createRequest())

    const promise = api('/font_families.json', options, config)
      .then(({ data }) => {
        const normalizedJson = normalize(data, Schemas.FONT_FAMILY)
        dispatch(updateEntities(normalizedJson))
        dispatch(createSuccess())

        return { success: true, data }
      })
      .catch((data) => {
        const errors = handleError(data)
        dispatch(createFailure(errors))

        return { success: false, errors }
      })

    return promise
  }
}

export function updateFontFamily(fontFamily, options){
  const config = {
    method: 'PUT',
    data: JSON.stringify({
      font_family: fontFamily,
    }),
  }

  return (dispatch) => {
    dispatch(updateRequest())

    const promise = api(`/font_families/${fontFamily.id}.json`, options, config)
      .then(({ data }) => {
        const normalizedJson = normalize(data, Schemas.FONT_FAMILY)
        dispatch(updateEntities(normalizedJson))
        dispatch(updateSuccess())

        return { success: true, data }
      })
      .catch((data) => {
        const errors = handleError(data)
        dispatch(updateFailure(errors))

        return { success: false, errors }
      })

    return promise
  }
}

// Reducer
export default function reducer(state = initialState, action = {}){
  switch (action.type){
    case FETCH_REQUEST:
      return {
        ...state,
        loadedForKeys: action.loadedForKeys || state.loadedForKeys,
        loading: true,
      }
    case FETCH_SUCCESS:
      return {
        ...state,
        loading: false,
        loaded: true,
        errors: [],
      }
    case FETCH_FAILURE:
      return {
        ...state,
        loading: false,
        loaded: false,
        errors: action.errors,
      }
    case CREATE_REQUEST:
      return {
        ...state,
        creating: true,
      }
    case CREATE_SUCCESS:
      return {
        ...state,
        creating: false,
        errors: [],
      }
    case CREATE_FAILURE:
      return {
        ...state,
        creating: false,
        errors: action.errors,
      }
    case UPDATE_REQUEST:
      return {
        ...state,
        updating: true,
      }
    case UPDATE_SUCCESS:
      return {
        ...state,
        updating: false,
        errors: [],
      }
    case UPDATE_FAILURE:
      return {
        ...state,
        updating: false,
        errors: action.errors,
      }
    default:
      return state
  }
}
